module.exports = {
	"fr": {
		"help-tool": {
			"button-text": "Aide",
			"support-button": "Obtenir de l'aide",
			"support-page": {
				"create-ticket": {
					"title": "Obtenir de l'aide",
					"instructions": "Envoyez votre demande ci-dessous et nous vous contacterons dans un délai d’un jour ouvrable.",
					"related-content": {
						"title": "Ils vous aideront peut-être à résoudre votre problème"
					},
					"fields": {
						"mid": {
							"label": "Sélectionner une boutique",
							"validation": "Boutique requise"
						},
						"phoneNumber": {
							"label": "Numéro de téléphone (facultatif)"
						},
						"topic": {
							"question": "Quel est le sujet de votre question ?",
							"label": "Choisir un sujet",
							"validation": "Sujet requis",
							"options": {
								"orders": "Commandes",
								"settlements": "Règlements",
								"agreements": "Accords",
								"others": "Autre"
							}
						},
						"subject": {
							"label": "Sujet",
							"validation": "Sujet requis"
						},
						"description": {
							"label": "Message",
							"validation": "Description requise"
						},
						"attachment": {
							"label": "Ajoutes des pièces jointes",
							"button": "Charger",
							"info": "Ajoutez des captures d'écran pour nous aider à résoudre le problème plus rapidement.",
							"supportedFileTypes": "Types de fichiers pris en charge : .png, .jpg, .pdf",
							"error": "La taille de tous les fichiers ne doit pas dépasser {maxSize} Mb"
						}
					},
					"submit": "Faire une demande",
					"service-unavailable-error": "Oups ! Une erreur s'est produite, réessayez dans quelques minutes. Si le problème persiste, {link} pour obtenir de l'aide.",
					"generic-error": "Nous n'avons pas pu traiter votre demande. Nos systèmes ont rompu toute communication pour le moment. Veuillez essayer de rafraîchir la page ou de revenir plus tard. Si le problème persiste, {link} pour obtenir de l'aide.",
					"contact-link": "contactez-nous"
				},
				"view-ticket": {
					"title": "C'est fait !",
					"details": "Nous avons bien reçu votre demande et nous vous contacterons dans un délai d’un jour ouvrable. Voici vos détails :",
					"ticket": "Demande n° {ticketId}",
					"email": "Adresse e-mail : {email}",
					"status": "Vous pouvez suivre le statut sur notre d'assistance.",
					"track": "Suivre le statut"
				}
			},
			"header": {
				"homeLink": "Réinitialiser"
			},
			"home": {
				"greeting": "Bonjour {givenName} ! En quoi pouvons-nous vous aider ?",
				"topics": "En quoi pouvons-nous vous aider ?"
			},
			"topics": {
				"expandButton": "Plus"
			},
			"feedback": {
				"title": "Cela vous a-t-il aidé(e) ?",
				"optionYes": "Oui, cela m'a aidé(e)",
				"optionNo": "Non, j'ai toujours besoin d'aide",
				"positiveFeedback": "Merci pour votre retour positif, cela nous aide beaucoup à vous proposer des articles plus pertinents à l'avenir."
			},
			"freeTextFeedback": {
				"title": "Aidez-nous à nous améliorer",
				"placeholder": "Pourquoi n'avez-vous pas trouvé ce contenu utile ?",
				"submitButton": "Envoyer",
				"feedbackMessage": "Merci pour votre retour, cela nous aide beaucoup à vous proposer des articles plus pertinents à l'avenir."
			},
			"relatedContent": {
				"title": "Contenu semblable"
			},
			"search": {
				"buttonLabel": "Rechercher",
				"input": "Rechercher des articles...",
				"loading": "Téléchargement en cours...",
				"results": {
					"contact": "Vous ne trouvez pas l'aide dont vous avez besoin ?",
					"empty": "Désolés, votre recherche n'a donné aucun résultat. Essayez de rechercher un terme différent.",
					"singleTopicFound": "Nous avons trouvé un sujet",
					"multipleTopicsFound": "Nous avons trouvé {count} sujets",
					"singleArticleFound": "Nous avons trouvé un article",
					"multipleArticlesFound": "Nous avons trouvé {count} articles"
				}
			},
			"contact": {
				"title": "Contactez-nous",
				"channelsIntro": "Contactez-nous pour obtenir de l'aide.",
				"businessDetailsTitle": "Vos informations commerciales",
				"businessDetailsName": "Nom de société",
				"businessDetailsEmail": "Adresse e-mail",
				"businessDetailsMid": "ID de marchand",
				"phone": {
					"title": "Appelez-nous",
					"paragraph": "Vous pouvez nous appeler les jours ouvrables durant nos heures d'ouverture. Si vous vous trouvez en Suède ou au Royaume-Uni, vous pouvez également nous appeler le week-end entre 10 h et 16 h."
				},
				"email": {
					"title": "Contactez-nous par e-mail",
					"paragraph": "Envoyez-nous un e-mail et nous vous répondrons dès que possible."
				}
			},
			"errorBoundary": {
				"title": "Une erreur s'est produite",
				"message": "Désolés, une erreur s'est produite. Vous pouvez cliquer sur le bouton « Retour » ci-dessous pour revenir à l'outils d'assistance ou sur « Obtenir de l'aide » pour nous contacter.",
				"resetButton": "Retour",
				"errorId": "ID d'erreur : {errorId}"
			},
			"tour": {
				"prev": "Précedent",
				"next": "Suivant",
				"done": "Terminer"
			},
			"notAvailableMobile": {
				"title": "Non disponible",
				"buttonBack": "Retour",
				"paragraph": "Ce contenu n'est pas disponible sur votre appareil. Essayez de l'ouvrir sur un appareil avec un écran plus grand, comme un ordinateur de bureau."
			},
			"shareButton": {
				"title": {
					"article": "Établir un lien profond avec cet article",
					"topic": "Établir un lien profond avec ce sujet",
					"tour": "Établir un lien profond avec ce voyage"
				},
				"radioItemHome": "Accueil de l'application",
				"descriptionHome": "Ouvre un article d'aide sur la page d'accueil du portail des marchands",
				"radioItemCurrent": "Page en cours",
				"descriptionCurrent": "Ouvre un article d'aide sur la page en cours"
			},
			"marketSelector": {
				"whichMarketToContact": "Quel marché souhaitez-vous contacter ?"
			}
		},
		"orientation": {
			"title": "Apprendre comment ..."
		},
		"helpbot": {
			"questions": {
				"whatDoYouNeedHelpWithPart1": "Bonjour {name} ! 👋 Je suis votre assistant Klarna.",
				"whatDoYouNeedHelpWithPart2": "Je peux vous donner la réponse à la majorité de vos questions en moins de cinq minutes.",
				"whatDoYouNeedHelpWithPart3": "Que puis-je faire pour vous aujourd’hui ?",
				"selectSupportChannel": "Veuillez sélectionner un canal pour contacter notre service d’assistance.",
				"selectPayoutIssue": "Parfait ! Sélectionnez maintenant un problème lié aux règlements 👇",
				"selectOrderIssue": "Parfait ! Sélectionnez maintenant un problème lié aux commandes 👇",
				"capturedOrders": "Avez-vous des commandes {link1} en cours ?",
				"capturedOrdersLink1": "enregistrée",
				"notPaidOrder": {
					"isScheduleFollowed": "Est-ce que votre {link1} (avec le délai de règlement) a été respecté ?",
					"isScheduleFollowedLink1": "calendrier de règlement",
					"isHoldbackOrDebt": "Si le délai de règlement a été dépassé, veuillez vérifier votre {link1}. Y a-t-il des retenues ou des dettes en raison de retours/renversements ?",
					"isHoldbackOrDebtLink1": "dernier fichier de règlements"
				},
				"paidWrongAmount": {
					"isScheduleFollowed": "Veuillez vérifier la date de l’enregistrement des commandes pour lesquelles vous attendez un paiement et prenez en compte le délai de règlement. Vous trouverez vos commandes {link1}. Les commandes pour lesquelles vous attendez un paiement ont-elles été enregistrées ?",
					"isScheduleFollowedLink1": "ici"
				},
				"changePaymentFrequency": "Avez-vous reçu plus de 30 commandes enregistrées par mois sur une période de 3 mois ?",
				"whenWillGetPaid": "La date de règlement dépend de votre calendrier de règlement et du délai de règlement indiqué dans votre contrat (Conditions générales). Si vous avez un doute sur la configuration de vos règlements, rendez-vous dans la section {link1}. Le calendrier de règlement (+ le délai de règlement) a-t-il été respecté ?",
				"whenWillGetPaidLink1": "Règlements",
				"thatHelped": "Merci pour votre feedback positif, cela nous permettra de vous apporter une aide encore plus pertinente à l’avenir.",
				"orders": {
					"haveUncapturedOrdersPart1": "Ah, je vois ! Avez-vous des commandes non enregistrées ?",
					"haveUncapturedOrdersPart2": "Si vous ne savez pas comment le vérifier, veuillez vous référer à {link1}.",
					"haveUncapturedOrdersPart2Link1": "cette page",
					"expirationDateSurpassed": "La date d’expiration a-t-elle été dépassée (généralement 28 jours) ?",
					"customerCreditPaymentMethod": "Le client a-t-il choisi de payer par crédit (facture, compte, prélèvement automatique) ?",
					"isOrderCaptured": "La commande est-elle {link1} ?",
					"isOrderCapturedLink1": "enregistrée"
				}
			},
			"options": {
				"payout": "Règlement",
				"orders": "Commandes",
				"otherIssue": "Autres problèmes",
				"whenPaidOrderNext": "Quand vais-je recevoir le prochain paiement ?",
				"notPaidOrder": "Je n’ai pas reçu de paiement",
				"paidWrongAmount": "J’ai reçu un montant incorrect",
				"changeHowOftenPaid": "Je veux modifier la fréquence de paiement",
				"dontKnowHowToCaptureOrder": "Je ne sais pas comment enregistrer une commande",
				"missedCaptureDeadline": "J’ai manqué la date limite d’enregistrement",
				"needToRefundAnOrder": "Je dois rembourser une commande",
				"yes": "Oui",
				"no": "Non",
				"partially": "Partiellement",
				"iNeedMoreHelp": "Vous avez d’autres questions ?",
				"thatHelped": "Cela m’a aidé",
				"contactSupportChannel": "Contactez les canaux d’assistance"
			},
			"explanations": {
				"noCapturedOrders": "Pour commencer, vous devez {link1}. Lorsque vous aurez enregistré la commande, nous verserons le montant sur votre compte bancaire. Les frais, retours et autres charges seront déduits de ce montant.",
				"noCapturedOrdersLink1": "Enregistrer une commande",
				"feesReturnsHoldbacks": "Les frais, retours et autres charges peuvent être déduits du montant de règlement. Veuillez vérifier que vous n’avez pas de retenues ou de dettes en raison de retours ou de renversements dans le {link1}.",
				"feesReturnsHoldbacksLink1": "dernier fichier de règlements",
				"notPaidOrder": {
					"scheduleFollowed": "Lorsque vous aurez enregistré la commande, nous verserons le montant sur votre compte bancaire en fonction de votre calendrier de règlement. Les frais, retours et autres charges seront déduits de ce montant. Veuillez vérifier la valeur de votre règlement dans votre {link1}.",
					"scheduleFollowedLink1": "dernier fichier de règlements",
					"noHoldback": "Veuillez vous assurer que les coordonnées bancaires saisies sont correctes et correspondent à la devise du règlement {link1}.",
					"noHoldbackLink1": "ici",
					"withHoldback": "Si la valeur des commandes capturées dépasse la dette, veuillez vérifier que vous avez saisi les coordonnées bancaires correspondant à la devise du règlement {link1}.",
					"withHoldbackLink1": "ici"
				},
				"whenPaidOrderNext": {
					"scheduleFollowed": "Vous recevrez le prochain règlement en fonction de votre calendrier de règlement + le délai de paiement."
				},
				"changePaymentFrequency": {
					"isAble": "Veuillez poursuivre en contactant nos canaux d’assistance ci-dessous.",
					"isUnable": "Malheureusement, vous ne répondez pas aux exigences pour changer votre calendrier de règlements."
				},
				"orders": {
					"uncapturedDynamicYes": "Ah, je vois, vous avez {number} commandes non enregistrées.",
					"uncapturedDynamicNo": "Je vois que vous n’avez pas de commandes non enregistrées",
					"uncapturedYesPart1": "Il est temps pour vous d’enregistrer des commandes ! Pour ce faire,",
					"uncapturedYesPart2": "1. Allez sur la page des commandes {link1}.",
					"uncapturesYesPart2Link1": "en cliquant ici",
					"uncapturedYesPart3": "2. Cliquez sur la référence Klarna de la commande que vous souhaitez enregistrer.",
					"uncapturedYesPart4": "3. Choisissez les articles ou ajoutez un montant que vous souhaitez enregistrer.",
					"uncapturedYesPart5": "4. Appuyez sur « Enregistrer ».",
					"uncapturedNoPart1": "Pour enregistrer une commande, vous devez d’abord disposer de commandes à enregistrer.",
					"uncapturedNoPart2": "Lorsque vous enregistrez une commande, vous confirmez que la commande a bien été envoyée au client. Vous devez le faire le même jour que vous envoyez la commande pour chaque commande. Lorsque vous enregistrez une commande, vous nous indiquez également que nous devons déclencher un règlement en votre faveur pour cette commande. En savoir plus sur l’enregistrement des commandes {link1}.",
					"uncapturedNoLink1": "ici",
					"customerCreditPaymentMethodNo": "Malheureusement, nous ne pouvons pas prolonger une commander qui a expiré. Vous devrez recréer la commande.",
					"expirationDateSurpassedYes": "Laissez-nous vous aider à prolonger la commande, veuillez contacter l’assistance via l’un des canaux ci-dessous.",
					"expirationDateSurpassedNo": "Rendez-vous sur {link1}. Sélectionnez la commande en cochant la case située à côté du numéro de référence Klarna. Cliquez sur Prolonger la date d’expiration, puis confirmez votre demande.",
					"expirationDateSurpassedNoLink1": "Commande > À enregistrer",
					"isOrderCapturedYesPart1": "Sélectionnez les articles à rembourser, puis cliquez sur Rembourser. Vous pouvez également cliquer en premier lieu sur Rembourser, avant de saisir le montant du remboursement. À vous de choisir !",
					"isOrderCapturedYesPart2": "Votre client recevra un remboursement de la somme qu’il a déjà payée sous 2 à 5 jours ouvrables, et ce montant sera déduit de votre prochain règlement.",
					"isOrderCapturedNo": "Si vous ne pouvez pas expédier une commande non enregistrée, vous pouvez {link1} l’intégralité de la commande. Allez sur {link2} et cliquez sur Annuler la commande.",
					"isOrderCapturedNoLink1": "annuler",
					"isOrderCapturedNoLink2": "page des commandes",
					"refundPartiallyCaptured": "Si vous avez partiellement enregistré une commande pour les articles expédiés, mais que vous ne pouvez pas honorer le reste de la commande, vous devez en annuler la partie non enregistrée. Allez sur le/la {link1}, cliquez sur Plus d’actions et sélectionnez Libérer.",
					"refundPartiallyCapturedLink1": "page des commandes"
				}
			},
			"messages": {
				"sorryToHearThat": "Je suis désolé de ne pas avoir pu vous aider. Vous allez bientôt être redirigé(e) vers notre service d’assistance."
			},
			"button": {
				"label": "Obtenir de l’aide"
			},
			"contact": {
				"chat": "Discuter avec un agent",
				"ticket": "Envoyer un ticket",
				"times": {
					"minutes": "Temps d’attente : {time} minute(s)",
					"hours": "Temps d’attente : {time} heure(s)",
					"days": "Temps d’attente : {time} jour(s)"
				}
			}
		}
	}
};